import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@hooks'

const SettingsApiKey = redirect('/integration/apikey')

export const Route = createFileRoute('/settings/apikey/')({
  component: SettingsApiKey,
})
